export default __webpack_public_path__ + "static/media/small-done.f04e77e0.svg";